import { useQuery } from "react-query";
import {
    ParamsPostUsersByWarehouse,
    PostUsersByWarehouseResponse,
} from "../../constants/types";
import axios from "../axios";
import qs from "query-string";

const handleRequest = async (params: ParamsPostUsersByWarehouse) => {
    const url = qs.stringifyUrl({
        url: "api/getusers",
        query: {
            warehouseId: params.warehouseId,
            size: params.size,
            page: params.page,
            search: `${params.search}`,
        },
    });
    const { data } = await axios.get<PostUsersByWarehouseResponse>(url);
    return data.data;
};

export default function useUsersByWarehouse(params: ParamsPostUsersByWarehouse) {
    return useQuery<PostUsersByWarehouseResponse["data"]>(
        ["users", params],
        () => handleRequest(params),
        { enabled: !!params.warehouseId },
    );
}
